import { create } from 'zustand';

interface SessionState {
  selectedContactId: string | null;
  gradingSessionCount: number;
  setSelectedContact: (id: string | null) => void;
  incrementGradingCount: () => void;
  resetGradingSession: () => void;
  reset: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  selectedContactId: null,
  gradingSessionCount: 0,
  setSelectedContact: (id) => set({ selectedContactId: id }),
  incrementGradingCount: () =>
    set((state) => ({ gradingSessionCount: state.gradingSessionCount + 1 })),
  resetGradingSession: () => set({ gradingSessionCount: 0 }),
  reset: () => set({ selectedContactId: null, gradingSessionCount: 0 }),
}));
